<template>
  <div :class="selected_report?.story_board || print_mode ? 'px-print' : 'container'">
    <DataCenterLoading v-if="toc_list.length === 0" />

    <template v-else>
      <b-row class="pt-5 dc-table">
        <b-col cols="3" lg="2">
          <DataCenterNav class="side-nav3 dc-nav" />
        </b-col>

        <b-col cols="9" lg="8">
          <div>
            <h2 v-if="selected_lv1_info" class="fw-600 mb-3">
              {{
                lang !== 'ENG'
                  ? selected_lv1_info.name
                  : selected_lv1_info.name_em
                  ? selected_lv1_info.name_em
                  : selected_lv1_info.name_ea
              }}
            </h2>

            <b-table-simple responsive class="table-borderless table-responsive">
              <b-tbody class="mb-2 border-0">
                <b-tr>
                  <b-td class="py-1 pl-1" :style="main_color_sub">
                    <span class="fw-600 f-140">
                      {{
                        lang !== 'ENG'
                          ? selected_lv2_info.name
                          : selected_lv2_info.name_em
                          ? selected_lv2_info.name_em
                          : selected_lv2_info.name_ea
                      }}
                    </span>
                    <span class="gray-500 f-90 fw-400 ml-1"> </span>
                  </b-td>
                </b-tr>

                <b-tr
                  v-for="(lv3_info, lv3_idx) in selected_lv2_info.children"
                  :key="'data_center_lv2_' + lv3_idx"
                >
                  <b-td class="" style="max-width: 200mm">
                    <!-- data_tables 넣을자리 -->
                    <div class="mb-3">
                      <p
                        v-if="lang === 'KOR' && lv3_info.contents"
                        class="page-no-break-inside mb-3"
                        style="word-wrap: break-word; white-space: pre-line"
                      >
                        <span v-html="lv3_info.contents"></span>
                      </p>
                      <p
                        v-else-if="lang !== 'KOR' && (lv3_info.contents_em || lv3_info.contents_ea)"
                        class="page-no-break-inside mb-3"
                        style="word-wrap: break-word; white-space: pre-line"
                      >
                        <span
                          v-html="
                            lv3_info.contents_em ? lv3_info.contents_em : lv3_info.contents_ea
                          "
                        ></span>
                      </p>
                      <ChartCanvas
                        v-if="lv3_info.item_id !== '' && lv3_info.type === 'chart'"
                        :key="`chart_${lv3_info.item_id}`"
                        :chart_id="lv3_info.item_id"
                        :print_mode="print_mode"
                        :viewer_mode="true"
                        class="mb-5"
                      />

                      <DataTable
                        v-if="lv3_info.item_id !== '' && lv3_info.type === 'table'"
                        :print_mode="print_mode"
                        :table_mode="table_mode"
                        :data_table_id="lv3_info.item_id"
                        :modal_table="modal_table"
                        :lazy_load="false"
                        :table_style="table_style"
                        :show_table_line="show_table_line"
                        :show_table_outline="show_table_outline"
                        :table_header_color="table_header_color"
                        :table_header_font_color="table_header_font_color"
                      />
                    </div>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import DataTable from './DataTable.vue';
import DataCenterLoading from './DataCenterLoading.vue';
import DataCenterNav from './DataCenterNav.vue';
import ChartCanvas from '@/components/writing_report/chart_subs/ChartCanvas.vue';

export default {
  name: 'DataCenterTable',
  components: {
    DataTable,
    ChartCanvas,
    DataCenterNav,
    DataCenterLoading
  },
  props: {
    modal_table: { type: Boolean, default: false },
    print_mode: { type: Boolean, default: false },
    table_mode: { type: String, default: 'accordion' },
    material_style_option: { type: String, default: 'outline' },
    table_style: { type: String, default: 'basic_table' },
    show_table_line: { type: Boolean, default: true },
    show_table_outline: { type: Boolean, default: false },
    table_header_color: { type: String, default: '#dedede' },
    table_header_font_color: { type: String, default: '#fffff' }
  },
  computed: {
    ...mapState('report_list', ['lang']),
    ...mapGetters('report_list', ['selected_report', 'current_report_code']),
    ...mapState('charts', ['toc_list']),
    ...mapState('data_center', ['lv1_key', 'lv2_key']),
    selected_lv1_info() {
      return this.toc_list.find(obj => obj.key === this.lv1_key);
    },

    selected_lv2_info() {
      if (this.lv1_key !== '' && this.lv2_key) {
        if (this.lv2_key === '') {
          return this.toc_list.find(obj => obj['key'] === this.lv1_key).children[0];
        } else {
          return this.toc_list
            .find(obj => obj['key'] === this.lv1_key)
            .children.find(obj => obj['key'] === this.lv2_key);
        }
      } else {
        return this.toc_list[0].children[0];
      }
    },
    main_color_sub() {
      if (this.material_style_option === 'fill') {
        return `background-color: ${this.selected_report.main_color}; color: white; border: 1px solid white; `;
      } else if (this.material_style_option === 'outline') {
        return (
          `color:` +
          this.selected_report.main_color +
          `; border-top: 1px solid ` +
          this.selected_report.main_color +
          `!important` +
          `; border-bottom: 1px solid ` +
          this.selected_report.main_color
        );
      } else {
        return `background-color: white; border-left: 3px solid ${this.selected_report.main_color}; border-bottom: 1px solid ${this.selected_report.sub_color}; border-top: 0px; border-right: 0px;`;
      }
    }
  },
  mounted() {
    this.getDCToC({ report_code: this.current_report_code });
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapActions('charts', ['getDCToC']),
    handleScroll() {
      const stickyStart = 400;
      this.isSticky = window.scrollY > stickyStart;
    }
  }
};
</script>

<style scoped>
.dc-table {
  min-height: 100vh;
}

.dc-nav {
  position: sticky;
  top: 90px;
  background: white;
  z-index: 2;
}
</style>
